<div class="chat-container">
  <div class="chat-messages" #messageContainer>
    @for (message of messages(); track message.id) {
      <div
        class="chat-message"
        [ngClass]="{
          'chat-message--user': message.sender === 'user',
          'chat-message--system': message.sender === 'system',
        }">
        <div class="chat-message__avatar">
          <mat-icon>{{
            message.sender === 'user' ? 'person' : 'support_agent'
          }}</mat-icon>
        </div>
        <div class="chat-message__content">
          <div class="chat-message__text">{{ message.text }}</div>
          <div class="chat-message__time">
            {{ message.timestamp | date: 'short' }}
          </div>
        </div>
      </div>
    }

    @if (isLoading()) {
      <div class="chat-message chat-message--system chat-message--loading">
        <div class="chat-message__avatar">
          <mat-icon>support_agent</mat-icon>
        </div>
        <div class="chat-message__content">
          <div class="chat-loading-indicator">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
        </div>
      </div>
    }
  </div>

  <mat-divider></mat-divider>

  <div class="chat-input">
    <mat-form-field
      appearance="outline"
      class="chat-input__field no-bottom-space">
      <textarea
        matInput
        placeholder="Type a message..."
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="10"
        [ngModel]="newMessage()"
        (ngModelChange)="newMessage.set($event)"
        (keydown.enter)="handleEnterKey($event)"></textarea>
    </mat-form-field>
    <button
      mat-icon-button
      color="primary"
      class="chat-input__send-button"
      [disabled]="!newMessage().trim()"
      (click)="sendMessage()">
      <mat-icon>send</mat-icon>
    </button>
  </div>
</div>
